import { POST } from "utils/fetchWrappers";
import { UpdateBinValue } from "./dto/updateBinValue.dto";
import { GET_BIN_FAILURE, GET_BIN_REQUEST, GET_BIN_SUCCESS, RESET_BIN_DATA, TRIGGER_RESET_BIN_DATA, UPDATE_BIN_FAILURE, UPDATE_BIN_REQUEST, UPDATE_BIN_SUCCESS } from "./updateBin.constants";
import { GET_BIN_VALUES, UPDATE_BIN } from "utils/API/apiUrls";
import { call, put, takeLatest } from "redux-saga/effects";
import { apiStatusCodes } from "utils/API/apiStatusCodes";
import { GetBinData } from "./dto/getBinData.dto";
import { toast } from "react-toastify";
import * as loaderActions from 'redux/common/loader/loader.actions';
function* updateBinValuesSagas(actions) {
  try {
    yield put(loaderActions.showLoader());
    const { payload } = actions;

    // Build the API request payload
    const request = new UpdateBinValue(payload);
    const response = yield call(POST, UPDATE_BIN, request);

    if (response?.data?.statusCode === apiStatusCodes.SUCCESS) {
      const responseData = response.data || [];
      // Dispatch success action with fetched entity list (even if it's empty)
      yield put({ type: UPDATE_BIN_SUCCESS, payload: responseData });
    } else {
      const errorMsg = response?.data?.errorMessage || 'Unexpected API error';
      // Handle case where API call was not successful
      yield put({ type: UPDATE_BIN_FAILURE, payload: errorMsg });
      toast.error(errorMsg);
    }
  } catch (error) {
    let errorPayload = 'Something went wrong while fetching data.';

    if (error?.response?.data) {
      errorPayload =
        error.response.data.errorMessage ||
        error.response.data.message ||
        errorPayload;
    } else if (error?.message) {
      errorPayload = error.message;
    }

    yield put({ type: UPDATE_BIN_FAILURE, payload: errorPayload });
    toast.error(errorPayload);
  }
  yield put(loaderActions.hideLoader());
}

function* getBinDataSagas(actions) {
  try {
    const { payload } = actions;

    // Build the API request payload
    const request = new GetBinData(payload);
    const response = yield call(POST, GET_BIN_VALUES, request);
    
    if (response?.data?.statusCode === apiStatusCodes.SUCCESS) {
      const responseData = response.data || [];
     
      // Dispatch success action with fetched entity list (even if it's empty)
      yield put({ type: GET_BIN_SUCCESS, payload: responseData });
    } else {
      const errorMsg = response?.data?.errorMessage || 'Unexpected API error';
      // Handle case where API call was not successful
      toast.error(errorMsg);
      // toast.error()
      yield put({ type: GET_BIN_FAILURE, payload: errorMsg });
    }
  } catch (error) {
    let errorPayload = 'Something went wrong while fetching data.';

    if (error?.response?.data) {
      errorPayload =
        error.response.data.errorMessage ||
        error.response.data.message ||
        errorPayload;
    } else if (error?.message) {
      errorPayload = error.message;
    }

    yield put({ type: GET_BIN_FAILURE, payload: errorPayload });
    toast.error(errorPayload);
  }
}
/**
 * Watcher saga that listens to ENTITY_FETCH_LIST_REQUEST
 * and triggers the worker saga to handle the side effect.
 */
function* resetBinDataSagas() {
  yield put({ type: RESET_BIN_DATA });
} 
export default function* updateBinSagas() {
  yield takeLatest(UPDATE_BIN_REQUEST, updateBinValuesSagas);
  yield takeLatest(GET_BIN_REQUEST, getBinDataSagas);
  yield takeLatest(TRIGGER_RESET_BIN_DATA, resetBinDataSagas);
}
